<section class="curation-editor-actions-{{curationItem?.type}}">
  <section class="curation-editor-actions" [ngSwitch]="curationStatus">
    <span class="icon__arrow_left curation-editor-actions_back"
          style="margin-right: 1.5rem;margin-left: 1.71rem; font-size: 2rem"
          (click)="goBack()">
    </span>
    <div class="curation-editor-actions-curation-details">
      <div class="curation-editor-actions-curation-line">
        <span class="curation-editor-actions-curation-type">{{getCurationType()}}</span>
        <span class="curation-editor-actions-curation-key" title={{curationKey}}
              [innerHTML]="escapeChevron(curationKey)"></span>
        <span *ngIf="getDiscipline() != ''" class="seperator"></span>
        <span class="curation-editor-actions-curation-discipline">{{getDiscipline()}}</span>
        <div *ngIf="curationItem?.type=='aberration' && evidence['tier'] != null && evidence['tier'] !=''"
             class="tier rectangle-{{evidence['tier']}}">Tier {{evidence['tier']}}</div>
        <div *ngIf="curationItem?.type=='aberration'" class="significance-levels">
          <span *ngIf="evidence['therapeuticMaxEvidLevel'] != null && evidence['therapeuticMaxEvidLevel'] != ''"
                class="significance-letter">Tx </span>
          <span *ngIf="evidence['therapeuticMaxEvidLevel'] != null"
                class="significance level-{{evidence['therapeuticMaxEvidLevel']}}">{{evidence['therapeuticMaxEvidLevel']}}</span>
          <span *ngIf="evidence['prognosticMaxEvidLevel'] != null && evidence['prognosticMaxEvidLevel'] != ''"
                class="significance-letter">Px </span>
          <span *ngIf="evidence['prognosticMaxEvidLevel'] != null"
                class="significance level-{{evidence['prognosticMaxEvidLevel']}}">{{evidence['prognosticMaxEvidLevel']}}</span>
          <span *ngIf="evidence['diagnosticMaxEvidLevel'] != null && evidence['diagnosticMaxEvidLevel'] != ''"
                class="significance-letter">Dx </span>
          <span *ngIf="evidence['diagnosticMaxEvidLevel'] != null"
                class="significance level-{{evidence['diagnosticMaxEvidLevel']}}">{{evidence['diagnosticMaxEvidLevel']}}</span>
        </div>
        <div class="curation-links-container">
          <span *ngIf="shouldShowLinkTable()" class="revised-data-link"
                (click)="showPopupTablePanel()">Items for review</span>
          <div class="revised-data-container" *ngIf="shouldShowLinkTable() && popupTableShown">
            <div class="arrow">
              <div class="arrow-wrapper"><span class="arrow-top"></span></div>
            </div>
            <div class="link-data-border">
              <ng-container *ngIf="shouldShowRevisedRelatedEntitiesTable()">
                <ng-container *ngTemplateOutlet="revisedEntitiesTable" container-content
                              content-type="dataTable"></ng-container>
                <ng-template #revisedEntitiesTable>
                  <div class="link-data-panel revised">
                    <table class="p-datatable">
                      <thead class="p-datatable-thead">
                      <tr>
                        <th *ngFor="let head of revisiedEntitiesTableData.columns">{{head}}</th>
                      </tr>
                      </thead>
                      <tbody class="p-datatable-tbody">
                      <tr *ngFor="let item of revisiedEntitiesTableData.rows">
                        <td *ngFor="let field of item?.data; let i = index" [class.revised-data-link]="i == 0"
                            (click)="linkClicked($event, (item && item.relateObject) ? item.relateObject.id: null)"
                            title="{{field}}">
                          {{field}}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="shouldShowNodesWithNotesTable()">
                <ng-container *ngTemplateOutlet="nodesWithNotesTable" container-content
                              content-type="dataTable"></ng-container>
                <ng-template #nodesWithNotesTable>
                  <div class="link-data-panel nodes">
                    <table class="p-datatable">
                      <thead class="p-datatable-thead">
                      <tr>
                        <th>Node ID</th>
                        <th>Node name (with added notes)</th>
                      </tr>
                      </thead>
                      <tbody class="p-datatable-tbody">
                      <tr *ngFor="let node of nodesWithNotes">
                        <td class="revised-data-link"
                            (click)="linkClicked($event, node.id, { showNotes: true })">{{node.id}}</td>
                        <td title="{{node.name}}">{{node.name}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!--<span class="curation-editor-actions-curation-discipline">{{getDiscipline()}}</span>-->

      <span *ngIf="revisedRelatedEntities.length > 0 && (!revisiedEntitiesTableData || revisiedEntitiesTableData?.columns.length == 0)"
            class="revised-data-shown">{{revisedRelatedEntitiesTitle}}
      </span>

    </div>

    <button
            *ngIf="sameOrganization"
            id="toggleNotesPanel"
            (click)="toggleNotesPanel()"
            genTooltip [tooltipHtml]="'Notes'" [tooltipPosition]="'BOTTOM'"
            class="img-btn notes-btn icon__dls-balloon-text curation-notes-button"
            [tooltipShow]="true">
      <i>
        <span class="new-notes-notification" *ngIf="newNotes > 0">{{newNotes}}</span>
      </i>
    </button>
    <button
            *ngIf="sameOrganization && !readOnlyUserMode"
            type="button"
            [disabled]="reassignButtonDisabled"
            (click)="executeReassignCurationItem()"
            class="img-btn notes-btn curation-reassign-button"
            genTooltip [tooltipPosition]="'BOTTOM'" [tooltipHtml]="'Reassign Item'"
            [tooltipShow]="true">
      <span class="icon__reassign"></span>
    </button>
    <gen-stop-workflow *ngIf="showStopWorkflowButton"
                       [currentWorkflow]="workflowRequest$ | async"
                       [tooltipText]="'Stop Workflow'"
                       [tooltipPosition]="'BOTTOM'"
                       [stopAction]=""
                       [cssClass]="'img-btn notes-btn fs4 scale'"
                       [styleItem]="{'font-size': '1.9rem', 'line-height': 1}"
    ></gen-stop-workflow>
    <div class="curation-editor-actions-buttons-wrapper" align="right" [ngSwitch]="curationStatus">
      <div class="right-conteiner">
        <div *ngIf="!readOnlyUserMode && curationItem?.type=='aberration'" class="curation-editor-actions-search">
          <gen-external-search
                  [defaultButtonText]="'Search'"
                  [panelButtonText]="'Search Google'"
                  [iconClass]="'icon__google-search'"
                  [data]="curationDataForSearch"
                  [searchFormConfigParams]="searchFormConfigParams"
                  [searchDataConfigParams]="searchDataConfigParams"
                  [searchURL]="googleSearchURL"
                  [panelShown]="shown">
          </gen-external-search>
          <gen-external-search
                  [defaultButtonText]="'Search'"
                  [panelButtonText]="'Search Pubmed'"
                  [iconClass]="'icon__pub-med-search'"
                  [data]="curationDataForSearch"
                  [searchFormConfigParams]="searchFormConfigParams"
                  [searchDataConfigParams]="searchDataConfigParams"
                  [searchURL]="pubmedSearchURL"
                  [panelShown]="shown">
          </gen-external-search>
        </div>

        <div class="button-wrapper" *ngIf="showPreviewButton">
          <gen-button id="curation-action-preview-button" class="curation-action-draft-btn"
                      (click)="executeStartPreview()"
                      [type]="'quite'"

                      [text]="'Preview'"></gen-button>
        </div>
        <ng-container *ngIf="!readOnlyUserMode">
          <i *ngIf="oldRevisionMessage" class="previous-version-icon icon__warning_background fs4_5"></i>
          <span *ngIf="oldRevisionMessage" class="previous-version-message">{{oldRevisionMessage}}</span>
          <!-- UX: where to put discard button ? -->
          <gen-button *ngIf="showDiscardForCurrentStatus()" class="curation-action-waitfordeletion-btn"
                      (click)="updateStatus(discardCommand, CURATION_EDITOR_ACTIONS.DISCARD)"
                      [type]="'quite'"
                      [text]="'Discard'"
                      [disabled]="buttonsDisabled || !isAssignee"
                      [iconClass]="'icon__cross deleteIconClass'"
                      genTooltip
                      [tooltipPosition]="'BOTTOM'"
                      [tooltipHtml]="'Discard curate item revision'"
          ></gen-button>
          <div *ngSwitchCase="(curationStatus === 'approved' || curationStatus === 'published') ? curationStatus : ''"
               class="button-wrapper">
            <gen-button class="curation-action-save-button curation-action-whitelist-save-btn" *ngIf="curatorUserMode"
                        (click)="saveWhiteListChanges()"
                        [type]="'quite'"
                        [disabled]="isSaveButtonDisabled()"
                        [text]="'Save'"></gen-button>
            <gen-button *ngIf="archiveEnabled || archiveAlwaysEnabled" class="curation-action-waitfordeletion-btn"
                        (click)="updateStatus(waitForArchiveCommand, CURATION_EDITOR_ACTIONS.ARCHIVE)"
                        [type]="'quite'"
                        [text]="'Archive'"
                        [disabled]="buttonsDisabled"
                        [iconClass]="'icon__cross deleteIconClass'"></gen-button>
            <gen-button class="curation-action-draft-btn curation-action-right-btn"
                        (click)="updateStatus(draftCommand, CURATION_EDITOR_ACTIONS.REVISE)"
                        [type]="'primary'"
                        [text]="'Revise'"
                        [disabled]="buttonsDisabled"
                        [iconClass]="'icon__revision editIconClass'"
                        genTooltip
                        [tooltipPosition]="'BOTTOM'"
                        [tooltipHtml]="'Revise curate item'"
            ></gen-button>
          </div>
          <span *ngSwitchCase="'waitforarchive'" class="button-container">
            <gen-button *ngIf="archiveEnabled" class="curation-action-approved-btn"
                        (click)="updateStatus(getRejectArchiveCommand(), CURATION_EDITOR_ACTIONS.REJECT_ARCHIVING)"
                        [type]="'quite'"
                        [text]="'Reject Archiving'"
                        [disabled]="buttonsDisabled || !isAssignee">
            </gen-button>
            <gen-button class="curation-action-deprecated-btn curation-action-right-btn"
                        (click)="updateStatus(archiveSubmittedCommand, CURATION_EDITOR_ACTIONS.ARCHIVE)"
                        [type]="'quite'"
                        [text]="'Archive'"
                        [iconClass]="'icon__cross deleteIconClass'"
                        [disabled]="buttonsDisabled || !isAssignee">
            </gen-button>
          </span>
          <div *ngSwitchCase="(curationStatus === 'draft' || curationStatus === 'reviewFeedbackReceived') ? curationStatus : ''"
               class="button-container">
            <gen-button class="curation-action-save-button curation-action-draft-btn"
                        (click)="updateStatus(curationStatus, CURATION_EDITOR_ACTIONS.SAVE)"
                        [type]="'quite'"
                        [disabled]="buttonsDisabled || !isAssignee"
                        [text]="'Save'"></gen-button>
            <gen-button *ngIf="curationStatus === 'draft' && archiveAlwaysEnabled"
                        class="curation-action-waitfordeletion-btn"
                        (click)="updateStatus(waitForArchiveCommand, CURATION_EDITOR_ACTIONS.ARCHIVE)"
                        [type]="'quite'"
                        [text]="'Archive'"
                        [disabled]="buttonsDisabled"
                        [iconClass]="'icon__cross deleteIconClass'"></gen-button>
            <gen-button class="curation-action-waitforapproval-btn curation-action-right-btn" *ngIf="!multiStepReview"
                        (click)="updateStatus(waitForApprovalCommand, CURATION_EDITOR_ACTIONS.SUBMIT_FOR_APPROVAL)"
                        [type]="'primary'"
                        [text]="'Submit for Approval'"
                        [disabled]="buttonsDisabled"
                        [iconClass]="'icon__checkmark approveIconClass'"></gen-button>
            <ng-container *ngIf="multiStepReview">
              <gen-button class="curation-action-waitforapproval-btn curation-action-right-btn" *ngIf="curatorUserMode"
                          (click)="executeSubmitCurationItemForReview()"
                          [type]="'primary'"
                          [disabled]="buttonsDisabled || !isAssignee"
                          [text]="'Submit For Review'"></gen-button>
              <gen-button class="curation-action-waitforapproval-btn curation-action-right-btn" *ngIf="publishUserMode"
                          (click)="updateStatus(publishedSubmittedCommand, CURATION_EDITOR_ACTIONS.PUBLISH)"
                          [type]="'primary'"
                          [text]="'Publish'"
                          [disabled]="buttonsDisabled || !isAssignee"
                          [iconClass]="'icon__checkmark approveIconClass'"></gen-button>
            </ng-container>
          </div>
          <div *ngSwitchCase="(curationStatus === 'waitforapproval' || curationStatus === 'inreview') ? curationStatus : ''"
               class="button-container">
            <gen-button class="curation-action-rejected-btn"
                        (click)="updateStatus(rejectedCommand, CURATION_EDITOR_ACTIONS.REJECT)"
                        [type]="'quite'"
                        [text]="'Reject'"
                        [disabled]="buttonsDisabled || !approvalUserMode || !isAssignee"></gen-button>
            <gen-button *ngIf="curationStatus === 'inreview' && archiveAlwaysEnabled"
                        class="curation-action-waitfordeletion-btn"
                        (click)="updateStatus(waitForArchiveCommand, CURATION_EDITOR_ACTIONS.ARCHIVE)"
                        [type]="'quite'"
                        [text]="'Archive'"
                        [disabled]="buttonsDisabled|| !approvalUserMode || !isAssignee"
                        [iconClass]="'icon__cross deleteIconClass'"></gen-button>
            <gen-button class="curation-action-approve-btn curation-action-right-btn"
                        (click)="updateStatus(multiStepReview ? approvedcommand : approveCommand, CURATION_EDITOR_ACTIONS.APPROVE)"
                        [type]="'primary'"
                        [text]="'Approve'"
                        [disabled]="buttonsDisabled || !approvalUserMode || !isAssignee"></gen-button>
          </div>
          <div *ngSwitchCase="'rejected'" class="button-container">
            <gen-button class="curation-action-draft-btn curation-action-right-btn"
                        (click)="updateStatus(draftCommand, CURATION_EDITOR_ACTIONS.EDIT)"
                        [type]="'primary'"
                        [text]="'Edit'"
                        [disabled]="buttonsDisabled"
                        [iconClass]="'icon__edit editIconClass'"></gen-button>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</section>
